import React, { useState, useContext, useEffect } from 'react'
import CampaignContext from '@/product/context/campaign/campaignContext'
import AlertContext from '../../../../product/context/alert/alertContext'
import AuthContext from '../../../../product/context/auth/authContext'
import CustomCommonContext from '../../../context/common/commonContext'
import HomeDepotContext from '../../../../product/context/thirdParty/homeDepot/homeContext'
import AsinContext from '../../../../product/context/thirdParty/asin/asinContext'
import StripeCardContext from '../../../../product/context/stripe/card/cardContext'
import StripeCustomerContext from '../../../../product/context/stripe/customer/customerContext'
import UserContext from '../../../../product/context/auth/authContext'
const HeadAlert = () => {
    const campaignContext = useContext(CampaignContext)
    const homeDepotContext = useContext(HomeDepotContext)
    const asinContext = useContext(AsinContext)
    const stripeCardContext = useContext(StripeCardContext)
    const stripeCustomerContext = useContext(StripeCustomerContext)
    const alertContext = useContext(AlertContext)
    const customCommonContext = useContext(CustomCommonContext)
    const authContext = useContext(AuthContext)
    const userContext = useContext(UserContext)
    const { setAlert } = alertContext
    const { getGlobalVariable, configVariables, allUISettings } =
        customCommonContext
    const { loadUser, callEnd } = authContext
    const {
        responseStatus: responseStatusCampaign,
        clearResponse: clearResponseCampaign,
    } = campaignContext
    const {
        updateProfile,
        responseStatus: responseStatusUser,
        clearResponse: clearResponseUser,
    } = userContext

    const {
        responseStatus: responseStatusHomeDepot,
        clearResponse: clearResponseHomeDepot,
    } = homeDepotContext

    const {
        responseStatus: responseStatusAsin,
        clearResponse: clearResponseAsin,
    } = asinContext
    const {
        responseStatus: responseStatusStripeCustomer,
        clearResponse: clearResponseStripeCustomer,
    } = stripeCustomerContext

    const {
        responseStatus: responseStatusStripeCard,
        clearResponse: clearResponseStripeCard,
    } = stripeCardContext
    useEffect(() => {
        if (responseStatusStripeCustomer) {
            if (responseStatusStripeCustomer.status === 'success') {
                if (responseStatusStripeCustomer.from == 'create') {
                    updateProfile(
                        { stripe_id: responseStatusStripeCustomer.data.id },
                        false
                    )
                }
            }
        }
    }, [responseStatusStripeCustomer])

    useEffect(() => {
        if (responseStatusUser) {
            if (
                responseStatusUser.from === 'updateProfile' ||
                responseStatusUser.from === 'updatePreference' ||
                responseStatusUser.from === 'userAddress'
            ) {
                if (responseStatusUser.status === 'success') {
                    loadUser()
                }
            }
        }
    }, [responseStatusUser])
    useEffect(() => {
        if (responseStatusCampaign) {
            if (!responseStatusCampaign.noAlert) {
                setAlert(
                    responseStatusCampaign.message,
                    responseStatusCampaign.status
                )
            }
            clearResponseCampaign()
        }
        if (responseStatusHomeDepot) {
            if (!responseStatusHomeDepot.noAlert) {
                setAlert(
                    responseStatusHomeDepot.message,
                    responseStatusHomeDepot.status
                )
            }
            clearResponseHomeDepot()
        }
        if (responseStatusAsin) {
            if (!responseStatusAsin.noAlert) {
                setAlert(responseStatusAsin.message, responseStatusAsin.status)
            }
            clearResponseAsin()
        }
        if (responseStatusStripeCustomer) {
            if (!responseStatusStripeCustomer.noAlert) {
                setAlert(
                    responseStatusStripeCustomer.message,
                    responseStatusStripeCustomer.status
                )
            }

            clearResponseStripeCustomer()
        }

        if (responseStatusStripeCard) {
            if (!responseStatusStripeCard.noAlert) {
                setAlert(
                    responseStatusStripeCard.message,
                    responseStatusStripeCard.status
                )
            }
            clearResponseStripeCard()
        }
    }, [
        responseStatusCampaign,
        responseStatusHomeDepot,
        responseStatusAsin,
        responseStatusStripeCard,
        responseStatusStripeCustomer,
    ])

    useEffect(() => {
        if (callEnd) loaderSet(false)
    }, [callEnd])

    useEffect(() => {
        if (allUISettings) {
            allUISettings.map((data, index) => {
                if (data.ui_key == 'primColor') {
                    document.documentElement.style.setProperty(
                        '--primColor',
                        data.ui_value
                    )
                } else if (data.ui_key == 'secColor') {
                    document.documentElement.style.setProperty(
                        '--secColor',
                        data.ui_value
                    )
                }
            })
        }
    }, [allUISettings])

    return <></>
}
export default HeadAlert
